module.exports = __webpack_public_path__ + "static/media/pom.618b748e.jpg";